var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18496_16454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.46875 3.75026H3.28125C3.4707 3.75026 3.64258 3.63698 3.71484 3.46121C3.78711 3.28543 3.74805 3.08427 3.61328 2.94951L2.70117 2.03744C4.17188 0.892952 6.30078 0.996463 7.65234 2.34797C9.11719 3.81275 9.11719 6.1857 7.65234 7.65049C6.1875 9.11527 3.81445 9.11527 2.34961 7.65049C2.15039 7.45128 1.97852 7.23449 1.83398 7.00598C1.64844 6.71498 1.26172 6.62904 0.970703 6.81458C0.679687 7.00012 0.59375 7.38683 0.779297 7.67783C0.970703 7.9825 1.19922 8.27155 1.46484 8.53522C3.41797 10.4883 6.58203 10.4883 8.53516 8.53522C10.4883 6.58217 10.4883 3.41824 8.53516 1.46519C6.69531 -0.376528 3.77539 -0.481992 1.81055 1.1488L0.800781 0.137123C0.666016 0.00431634 0.464844 -0.0366975 0.289063 0.0355651C0.113281 0.107828 0 0.279696 0 0.469141V3.28153C0 3.54128 0.208984 3.75026 0.46875 3.75026Z",
    fill: "#F14242"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18496_16454"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetry);
export default __webpack_public_path__ + "static/media/retry.37822d6b035fd42d357767b86bc13195.svg";
export { ForwardRef as ReactComponent };